import React, { useEffect, useState } from "react";
import "../assets/css/main.css";
import logo1 from "../assets/images/logo1.png";

function WelcomeBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Simulating loading or some asynchronous operation
    const timer = setTimeout(() => {
      setShowBanner(true);
    }, 0); // Adjust the delay according to your needs or remove it if not needed

    // Cleanup function to clear the timer
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="banner" className={`fade-in ${showBanner ? "visible" : ""}`}>
      <div className="inner">
        <div className="logo">
          <img src={logo1} alt="Logo" width="400" />
        </div>
        <h2>Medical and Consumer Device Development</h2>
        <p>Professional product development consulting services</p>
      </div>
    </section>
  );
}

export default WelcomeBanner;
